import { Content } from './Content';

export interface GizmoData {
  id: string;
  title: string;
  direction: [x: number, y: number, z: number];
  size?: string;
  icon?: string;
  content: Content;
}

export interface SceneData {
  title: string;
  version: string;
  builtFor: string;
  isDraft?: boolean;
  bg: string;
  initialRotation?: [x: number, y: number, z: number];
  gizmos: GizmoData[];
}

export interface Scene {
  id: string;
  data: SceneData;
}

const _loadSceneData = async (sceneID: string): Promise<SceneData> => {
  // Fetch Scene File
  const response = await fetch(`projects/${sceneID}/scene.json`, {
    cache: 'no-store',
  }).catch((err) => {
    console.error(
      `An error occurred while fetching the scene '${sceneID}'\n`,
      err
    );
    throw new Error('Unable to load scene.');
  });

  // Parse Scene File
  const data: SceneData = await response.json().catch((err) => {
    console.error(
      `An error occurred while parsing the scene '${sceneID}'\n`,
      err
    );
    throw new Error('Unable to load scene.');
  });

  // Return SceneData
  return data;
};

export const loadScene = async (sceneID: string): Promise<Scene> => {
  const data = await _loadSceneData(sceneID);
  return { id: sceneID, data };
};
